import {Component} from '@angular/core';
import {ListViewItem} from '@domain/common/list-view/list-view-item';
import {ExportClef} from '@domain/admin/parametre/api/clefs/ExportClef';
import {ConfirmService} from '@share/component/confirmation/confirm.service';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {filter} from 'rxjs/operators';
import {ApiClefsService} from '@services/admin/parametre/api/api-clefs.service';
import {handleResult} from "@share/utils/handle-result";
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import {ApiClefAddComponent} from "@components/admin/parametre/api/clefs/add/api-clef-add.component";

/**
 * Item de liste pour l'affichage d'une clef API
 *
 * @author Lionel Gimenez
 */
@Component({
    selector: 'api-clef-item',
    templateUrl: './api-clef-item.component.html'
})
export class ApiClefItem extends ListViewItem<ExportClef> {
    /**
     * Constructeur
     */
    constructor(
        private confirmService: ConfirmService,
        private translateService: TranslateService,
        private toastrService: ToastrService,
        private apiClefsService: ApiClefsService,
        private matDialog: MatDialog,
    ) {
        super();
    }

    /**
     * Suppression de la clef depuis la ListView
     */
    deleteClef(): void {
        //Confirmation de la suppression
        this.confirmService
            .showConfirm(this.translateService.instant('global.suppression.confirmation'))
            .pipe(filter(isConfirmed => isConfirmed))
            .subscribe({
                next: () => {
                    //Appel service front pour suppression
                    this.apiClefsService.deleteClef(this.data.clef)
                        .pipe(handleResult(this.translateService,this.toastrService,'global.success.suppression','global.errors.suppression'))
                        .subscribe(() => this.liste.extraOptions.refresh());
                }
            });
    }

    /**
     * Ouverture du détail
     * */
    onSelect() {
        //Ouverture de la boite de dialogue
        this.matDialog.open(ApiClefAddComponent,{
            width: '60%',
            data: {
                ancienneClef: this.data
            }
        }).afterClosed().subscribe(refresh => {
            if (refresh) {
                //On met � jour la liste
                this.liste.refresh && this.liste.refresh();
            }
        });
    }
}
